<template>
  <div class="dashboard-container">  
    <CardStat />
    <div class="card">
      <!-- Colonne 1 -->
      <div>
        <!-- Liste Recommandations -->
        <div class="dashboard-card"><ListePriorisée /></div>
      </div>
      
      <!-- Colonne 2 -->
      <transition name="fade" mode="out-in">
        <ChartBar />
      </transition>
   </div>
  </div>
 
 </template>
 
   <script>
  import ListePriorisée from '@/components/mandat/ListePriorisée.vue';
  import CardStat from '@/components/mandat/CardStat.vue';
  import ChartBar from '@/components/mandat/ChartBar.vue';
 
   export default {
     components: {
       ListePriorisée,
       CardStat,
       ChartBar
     }
   }
   </script>
 
<style scoped>
.dashboard-container {
  display: flex;
  flex-direction: column;
  gap: 32px;
  padding: 0;
}

.card {
  display: grid;
  grid-template-columns: 1fr;
  gap: 28px;
}

.dashboard-card {
  background: rgba(255, 255, 255, 0.72);
  border: 1px solid rgba(212, 175, 55, 0.2);
  border-radius: 12px;
  padding: 20px;
  box-shadow: var(--shadow-md, 0 4px 14px rgba(10, 26, 47, 0.08));
  backdrop-filter: blur(10px);
}
 
 @media (max-width: 768px) {
   .dashboard-container {
     gap: 24px;
   }
   
   .card {
     gap: 20px;
   }
   
   .dashboard-card {
     padding: 16px;
   }
 }
 
 @media (max-width: 480px) {
   .dashboard-container {
     gap: 20px;
   }
   
   .card {
     gap: 16px;
   }
 }
 </style>
